import type {RunToggleState} from '../../workspace/runToggle';
import {observeCriticalWorkflowInteraction} from '../useCriticalWorkflowTrigger';

export function observeRunVisibilityCriticalWorkflow({
  event,
  isGroup,
  visibilityState,
}: {
  event: unknown;
  isGroup: boolean;
  visibilityState: RunToggleState;
}): boolean {
  return observeCriticalWorkflowInteraction({
    workflow: 'row-visibility-toggled',
    windowDurationMs: 4_000,
    event,
    workflowContext: {
      isGroup,
      nextVisibilityState: visibilityState === 'checked' ? 'hidden' : 'visible',
    },
  });
}
